export default __webpack_public_path__ + "static/media/jr_doll.e2a92f88.png";